import { BASE_URL } from '../config';

export interface DailyPuzzle {
  id: string;
  date: string;
  imageUrl: string;
  difficulty: number; // Grid size
  seed: number; // Seeded RNG seed (0 = use Math.random)
  title?: string;
}

// Minimum date for daily puzzles (October 2025)
//export const MIN_PUZZLE_DATE = new Date('2025-10-01');

// Cache for fetched puzzles to avoid repeated API calls
const puzzleCache = new Map<string, DailyPuzzle>();

export async function getDailyPuzzleByDate(dateString: string): Promise<DailyPuzzle | undefined> {
  // Check cache first
  if (puzzleCache.has(dateString)) {
    return puzzleCache.get(dateString);
  }

  try {
    const response = await fetch(`${BASE_URL}/Rest/daily/${dateString}`);

    if (!response.ok) {
      if (response.status === 404) {
        console.log('No puzzle available from API for date:', dateString);
        return undefined;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Extract puzzle from result wrapper
    const puzzle: DailyPuzzle = data.result || data;

    // Validate that the puzzle has required fields
    if (!puzzle.imageUrl) {
      console.warn('API returned puzzle without imageUrl');
      return undefined;
    }

    // Cache the puzzle
    puzzleCache.set(dateString, puzzle);

    return puzzle;
  } catch (error) {
    console.error('Error fetching daily puzzle:', error);
    return undefined;
  }
}

export function getDailyPuzzleById(id: string): DailyPuzzle | undefined {
  // Check cache
  for (const puzzle of puzzleCache.values()) {
    if (puzzle.id === id) {
      return puzzle;
    }
  }

  return undefined;
}

export async function getTodaysPuzzle(): Promise<DailyPuzzle | undefined> {
  const today = new Date();
  const dateString = today.toISOString().split('T')[0];
  return await getDailyPuzzleByDate(dateString);
}
